import React from 'react';
import {
  ASSET_TYPE,
  ASSET_TYPE_OPTION_LIST,
  AssetItem,
  LIABILITY_TYPE_OPTION_LIST,
  LiabilityItem,
  REPORT_ITEM_TYPE,
  REPORT_ITEM_TYPE_OPTION_LIST,
  REPORT_OWNER_TYPE,
  ReportItem,
  ReportOwnerType,
} from '../../type/AssetReport.type';

export interface AddAssetReportModalEditTableData {
  owner: ReportOwnerType;
  duplicateNameList: string[];
  reportItemList: ReportItem[];
  handleReportItemChange: (index: number, field: any, value: string | number) => void;
  handleDeleteReportItem: (index: number) => void;
}

const AssetReportModalEditTable = ({
  owner,
  duplicateNameList,
  reportItemList,
  handleReportItemChange,
  handleDeleteReportItem,
}: AddAssetReportModalEditTableData) => {
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th
            scope="col"
            className="px-2 py-2 w-20 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            구분1
          </th>
          <th
            scope="col"
            className="px-2 py-2 w-20 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            구분2
          </th>
          <th scope="col" className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            이름
          </th>
          <th scope="col" className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            금액
          </th>
          <th scope="col" className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            원금
          </th>
          <th scope="col" className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            배당금
          </th>
          <th
            scope="col"
            className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          ></th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {reportItemList.filter((reportItem) => reportItem.owner === owner).length > 0 ? (
          reportItemList.map(
            (reportItem, index) =>
              reportItem.owner === owner && (
                <tr
                  key={index}
                  className={`hover:bg-gray-50 ${
                    duplicateNameList.some(
                      (duplicateName) =>
                        duplicateName.split('!!!!')[0] === reportItem.name &&
                        duplicateName.split('!!!!')[1] === reportItem.type &&
                        duplicateName.split('!!!!')[2] === reportItem.owner,
                    )
                      ? 'bg-red-300'
                      : reportItem.prevExistYn === false && 'bg-yellow-50'
                  }`}
                >
                  <td className={`relative px-2 py-2 whitespace-nowrap w-20`}>
                    {reportItem.prevExistYn === false && (
                      <div className="absolute left-0 -top-3 z-20">
                        <span className="text-xs text-blue-600 bg-blue-100 px-1 py-0.5 rounded-full animate-fade-out">
                          NEW
                        </span>
                      </div>
                    )}
                    <select
                      value={reportItem.type}
                      onChange={(e) => handleReportItemChange(index, 'type', e.target.value)}
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    >
                      {REPORT_ITEM_TYPE_OPTION_LIST.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap w-20">
                    <select
                      value={
                        reportItem.type === REPORT_ITEM_TYPE.ASSET
                          ? (reportItem as AssetItem).assetType
                          : (reportItem as LiabilityItem).liabilityType
                      }
                      onChange={(e) =>
                        handleReportItemChange(
                          index,
                          reportItem.type === REPORT_ITEM_TYPE.ASSET ? 'assetType' : 'liabilityType',
                          e.target.value,
                        )
                      }
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    >
                      {reportItem.type === REPORT_ITEM_TYPE.ASSET
                        ? ASSET_TYPE_OPTION_LIST.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))
                        : LIABILITY_TYPE_OPTION_LIST.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                    </select>
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap">
                    <input
                      type="text"
                      value={reportItem.name}
                      onChange={(e) => handleReportItemChange(index, 'name', e.target.value)}
                      placeholder="자산명 입력"
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap">
                    <input
                      type="number"
                      value={reportItem.amount === 0 ? '' : reportItem.amount}
                      onChange={(e) =>
                        handleReportItemChange(index, 'amount', e.target.value === '' ? 0 : Number(e.target.value))
                      }
                      placeholder="0"
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap">
                    <input
                      type="number"
                      disabled={(reportItem as AssetItem).assetType !== ASSET_TYPE.INVESTMENT}
                      value={(reportItem as AssetItem).principalAmount ? (reportItem as AssetItem).principalAmount : ''}
                      onChange={(e) =>
                        handleReportItemChange(index, 'principalAmount', e.target.value === '' ? 0 : Number(e.target.value))
                      }
                      placeholder="0"
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap">
                    <input
                      type="number"
                      disabled={
                        reportItem.type !== REPORT_ITEM_TYPE.ASSET ||
                        (reportItem as AssetItem).assetType !== ASSET_TYPE.INVESTMENT
                      }
                      value={
                        reportItem.type === REPORT_ITEM_TYPE.ASSET && (reportItem as AssetItem).dividendAmount
                          ? (reportItem as AssetItem).dividendAmount
                          : ''
                      }
                      onChange={(e) =>
                        handleReportItemChange(index, 'dividendAmount', e.target.value === '' ? 0 : Number(e.target.value))
                      }
                      placeholder="0"
                      className="block w-full text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    />
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap">
                    <button
                      onClick={() => handleDeleteReportItem(index)}
                      className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ),
          )
        ) : (
          <tr>
            <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-500" colSpan={7}>
              {owner === REPORT_OWNER_TYPE.HUSBAND ? '남편의' : '아내의'} 엑셀 파일을 업로드하면 데이터가 이곳에
              표시됩니다.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AssetReportModalEditTable;
